class DisplayObserver {

  constructor(observer) {

    this.stopped = false;
    this.destroyed = false;
    this.events = [];
    this.stopObservation = null;
    this.serverPayloadSize = 10; // 10 events
    this.lastStoredAt = null;

    this.observer = observer;

  }

  async storeEvents(events) {

    const now = Date.now();

    this.observer.emitDisplayEvent(events, now - this.lastStoredAt);

    this.lastStoredAt = now;

  }

  handleDisplayChangeEvent(event) {

    this.events.push(event);

    if (this.events.length < this.serverPayloadSize) {
      return;
    }

    const events = [...this.events];

    this.events = [];

    this.storeEvents(events);

  }

  destroy() {

    if (this.destroyed === true) {
      return;
    }

    this.stopObservation();

    this.storeEvents(this.events);

    this.observer = null;

    this.destroyed = true;

  }

  start() {

    this.lastStoredAt = Date.now();

    this.stopObservation = window.rrwebRecord({
      emit: this.handleDisplayChangeEvent.bind(this),
      checkoutEveryNms: 1000 * 60 * 2
    });

    this.stopped = false;

  }

  stop() {

    // There was a date related issue elsewhere.
    // It causes stop method in a wrong time.
    // The next check is to handle that.
    // If the date related issue is resolved, this check can be deleted.
    if (this.stopObservation === null) {
      return;
    }

    this.stopObservation();
    this.stopped = true;

  }

}

export default DisplayObserver;